import React from 'react';
import { useDispatch } from 'react-redux';

import { SvgIcon } from '@interlayer/js/app/components/common/SvgIcon';
import { Button } from '@interlayer/js/components/common/Button';

import { useTranslations } from '@core/js/hooks/i18n';

import { useIsMultiColumn } from '@interlayer/js/app/components/main/Registration/hooks/storeData/useIsMultiColumn';
import { useStepNumber } from '@interlayer/js/app/components/main/Registration/hooks/storeData/useStepNumber';
import { useDistributorForRegType } from '@interlayer/js/app/components/main/Registration/hooks/useDistributorForRegType';
import { useInMobile } from '@interlayer/js/app/hooks/device/hooks/useMediaQuery';
import { useNavigateToHome } from '@interlayer/js/app/hooks/navigate/useNavigateToHome';
import { useDynamicTags } from '@interlayer/js/app/hooks/useDynamicTags';
import { setIsShowClosePopup } from '@interlayer/js/app/store/reducers/Registration/actions';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';
import { useLoginPopup } from '@interlayer/js/components/popups/LoginPopup/hooks';

import { BackRegArrow } from '../BackRegArrow';

import style from './HeaderMobileReg.scss';

export const HeaderMobileReg: React.FC = () => {
    const isMobile = useInMobile();
    const dispatch = useDispatch();
    const showLoginPopup = useLoginPopup();
    const stepNumber = useStepNumber();
    const navigateToHome = useNavigateToHome();
    const isMultiColumn = useIsMultiColumn();
    const t = useTranslations('playtech.mobile.system.registration.');
    const [dTagShowLoginBtnOnRegistration] = useDynamicTags([DYNAMIC_TAG_NAMES.showLoginBtnOnRegistration]);

    const isFirstStepReg = useDistributorForRegType({
        registration: false,
        upgrade: false,
        joinNow: true
    });

    const handlerNavigateToHome = () => {
        if (stepNumber === 0) {
            navigateToHome();
            return;
        }

        dispatch(setIsShowClosePopup(true));
    };

    return (
        <div className={style.container}>
            <div className={style.leftBlock}>
                {isMobile && !isMultiColumn && !isFirstStepReg && (
                    <BackRegArrow />
                )}
            </div>

            <div className={style.rightBlock}>
                {isMobile && isFirstStepReg && dTagShowLoginBtnOnRegistration === 'true' && (
                    <Button
                        size="small"
                        className={style.loginBtn}
                        onClick={showLoginPopup}
                    >
                        {t('btn.login')}
                    </Button>
                )}

                <SvgIcon
                    className={style.navigateToHome}
                    type="close-popup"
                    onClick={handlerNavigateToHome}
                />
            </div>
        </div>
    );
};
